
export default function Gallery() {
  const images = [
    {
      url: 'https://static.readdy.ai/image/c1d0616d0c190b59a0ba1f5a87b1a045/60ec3cbf8ff0fe71ea15f5cce477da0c.jpeg',
      title: 'Precision Cuts'
    },
    {
      url: 'https://static.readdy.ai/image/c1d0616d0c190b59a0ba1f5a87b1a045/dd7854d9407d16eb65f81d80e189a8ed.jpeg',
      title: 'Traditional Shaves'
    },
    {
      url: 'https://static.readdy.ai/image/c1d0616d0c190b59a0ba1f5a87b1a045/e47ddf01c098e15aa71a92c8ead14b92.jpeg',
      title: 'Beard Styling'
    },
    {
      url: 'https://static.readdy.ai/image/c1d0616d0c190b59a0ba1f5a87b1a045/1eab643d0f34e6591b52827f192d8f6c.jpeg',
      title: 'Modern Styles'
    },
    {
      url: 'https://static.readdy.ai/image/c1d0616d0c190b59a0ba1f5a87b1a045/77c7c381a22a40241ac9fa1348dde5b0.jpeg',
      title: 'Premium Setup'
    },
    {
      url: 'https://static.readdy.ai/image/c1d0616d0c190b59a0ba1f5a87b1a045/9ab4caaeae952fe0b1a5d4d405e3f6d9.jpeg',
      title: 'Finishing Touch'
    }
  ];

  return (
    <section id="gallery" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">Our Work</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Take a look at our craftsmanship and the transformations we create every day
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <div 
              key={index}
              className="relative group overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer aspect-square"
            >
              <img 
                src={image.url}
                alt={image.title}
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6 w-full">
                  <h3 className="text-2xl font-bold text-white">{image.title}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
